<template>
  <div class="PageContent" id="PageContent">
	<slot></slot>
  </div>
</template>

<script>
  import PageTitle from '../molecules/PageTitle.vue'
  
  export default {
    name: "PageContent",
    components: {
      PageTitle
    },
    computed: {},
    methods: {}
  }
</script>

<style scoped="">
.PageContent {
	position: relative;
	overflow: auto;
	padding: 0.5% 20px 20px 20px;
}
</style>
